import * as React from "react";
import { forwardRef } from "react";
const SvgGoBack = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 30, height: 28, viewBox: "0 0 30 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M15 22.6851L5 13.6111L15 4.53699L16.3125 5.72796L8.5625 12.7604H25V14.4618H8.5625L16.3125 21.4942L15 22.6851Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgGoBack);
export { ForwardRef as ReactComponent };
